import React, { Component } from "react"
import moment from "moment"
import axios from "axios"
import AxiosConfig from "../../../../utilities/AxiosConfig"
import { Accordion, Card, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap"
import EmployeeDataTypes from "../../Types/EmployeeTypes"
import NewIncident from "./Incident/NewIncident/NewIncident"
import Incident from "./Incident/Incident"
import WorkCompReferenceTypes from "../../Types/WorkCompReferenceTypes"
import ReferenceTypes from "../../Types/ReferenceTypes"
import Naggy from "../../../../utilities/naggy/Naggy"
import "./WorkersComp.css"

interface WorkersCompProps {
    employee: EmployeeDataTypes
    workersCompItems: Array<any>
    refresh: Function
    hasEdits: Function
    isDirty: boolean
    reference: ReferenceTypes
    userId: number | string
    readOnly: boolean
}

type WorkersCompTypes = {
    createNewIncident: boolean
    viewAll: boolean
    workCompReference: WorkCompReferenceTypes | null
    selectedIncident: number
    ascending: boolean
}

class WorkersComp extends Component<WorkersCompProps, WorkersCompTypes> {

    discardMsg = "Discard Changes?"


    state = {
        viewAll: false,
        createNewIncident: false,
        workCompReference: { incidentStatus: [], incidentTypes: [], states: [] },
        selectedIncident: -1,
        ascending: true
    }

    componentDidMount() {
        this.getReference()
    }

    getReference = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/workComp/reference", AxiosConfig.configValue("min"))
            .then(res => {
                this.setState({ workCompReference: res.data })
            }).catch(err => {
                //console.log(err)
            })
    }

    // toggleNewIncident = () => {
    //     if (this.state.createNewIncident) {
    //         this.setState({ createNewIncident: false })
    //     } else {
    //         this.setState({ createNewIncident: true })
    //     }
    // }

    toggle = (key: string) => {
        let temp: any = this.state
        if (!temp[key]) {
            temp[key] = true
        } else {
            temp[key] = false
        }
        this.setState(temp)
    }

    toggleViewAll = (id?: number, skipToggle?: boolean) => {
        if (!skipToggle) {
            if (this.state.viewAll) {
                this.setState({ viewAll: false })
            } else {
                this.setState({ viewAll: true })
            }
        } else if (skipToggle) {
            this.setState({ viewAll: true })
        }
        if (id && id > 0) {
            const self = this
            setTimeout(() => {
                let elem = document.getElementById(`work-comp-item-${id}`)
                if (elem) {
                    elem.click()
                    self.toggleViewAll(0, true)
                } else {
                    self.toggleViewAll(id, true)
                }
            }, 50)
        }
    }

    setOpenIncident = (index: number) => {
        if (index === this.state.selectedIncident) {
            this.setState({ selectedIncident: -1 })
        } else {
            this.setState({ selectedIncident: index })
        }
    }


    sortWorkCompItems = (items: Array<any>) => {
        if (this.state.ascending) {
            return items.sort((a, b) => a.WorkersCompensationIncidentId - b.WorkersCompensationIncidentId)
        } else {
            return items.sort((a, b) => b.WorkersCompensationIncidentId - a.WorkersCompensationIncidentId)
        }
    }

    setClaimCount = (open: number, all: number) => {
        let elem = document.getElementById("workers-comp-claim-count")
        if (elem) {
            if (this.state.viewAll) {
                elem.innerHTML = `Workers Comp (${all})`
            } else {
                elem.innerHTML = `Workers Comp (${open})`
            }
        }
    }

    render() {

        let workersCompItems = []
        let open = 0
        let all = 0

        if (this.state.viewAll) {
            workersCompItems = this.props.workersCompItems
        } else {
            for (let i = 0; i < this.props.workersCompItems.length; i++) {
                if (this.props.workersCompItems[i].IncidentStatusTypeDesc.toLowerCase() === "open") {
                    workersCompItems.push(this.props.workersCompItems[i])
                }
            }
        }

        workersCompItems = this.sortWorkCompItems(workersCompItems)

        for (let i = 0; i < this.props.workersCompItems.length; i++) {
            if (this.props.workersCompItems[i].IncidentStatusTypeDesc.toLowerCase() === "open") {
                open++
                all++
            } else {
                all++
            }
        }

        this.setClaimCount(open, all)

        const WorkCompToolTip = (text: string) => (
            <Tooltip id="uac-tool-tip">
                {text}
            </Tooltip>
        )

        // //console.log(workersCompItems)

        // //console.log("read only?", this.props.readOnly)

        const readOnly = !this.props.readOnly


        return (
            <div className="WorkersComp" id="workers-comp">
                <span id="work-comp-space-taker-upper" className="material-icons">personal_injury</span>
                {this.state.workCompReference.incidentTypes.length === 0 && <Spinner id="waiting-work-comp-ref-spinner" animation="border" />}
                {this.state.workCompReference.incidentTypes.length > 0 && this.state.selectedIncident === -1 && <div className="WorkersCompTopRightControls">
                    <div className="WorkerCompAddIncidentWrapper">
                        <span className="material-icons" onClick={() => this.toggle("createNewIncident")}>add</span>
                    </div>
                    <div className="WorkersCompViewTypeToggle">
                        <div id="workers-comp-view-open-wrapper" onClick={() => this.toggleViewAll()}>
                            <p>Open ({open})</p>
                            {!this.state.viewAll && <div className="WorkersCompViewTypeToggleChecked"></div>}
                            {this.state.viewAll && <div className="WorkersCompViewTypeToggleUnchecked"></div>}
                        </div>
                        <div id="workers-comp-view-all-wrapper" onClick={() => this.toggleViewAll()}>
                            <p>All ({all})</p>
                            {this.state.viewAll && <div className="WorkersCompViewTypeToggleChecked"></div>}
                            {!this.state.viewAll && <div className="WorkersCompViewTypeToggleUnchecked"></div>}
                        </div>
                    </div>
                    {!this.state.ascending && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={WorkCompToolTip("Sort Ascending")}>
                        <div className="WorkCompSortItems" onClick={() => this.toggle("ascending")}>
                            <span id="work-comp-sort-desc" className="material-icons">sort</span>
                        </div>
                    </OverlayTrigger>}
                    {this.state.ascending && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={WorkCompToolTip("Sort Descending")}>
                        <div className="WorkCompSortItems" onClick={() => this.toggle("ascending")}>
                            <span id="work-comp-sort-asc" className="material-icons">sort</span>
                        </div>
                    </OverlayTrigger>}
                </div>}
                {this.state.selectedIncident === -1 && <div className="AllWorkersCompItems">
                    {workersCompItems.map((item, index) =>
                        <div className="WorkersCompItem" key={`workers-comp-item-${index}`}>
                            <Accordion className="WorkersCompCard">
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey={`${index}`}>
                                        <div className="WorkersCompItemCardHeader" id={`work-comp-item-${item.WorkersCompensationIncidentId}`} onClick={() => this.setOpenIncident(index)}>
                                            <p id="work-comp-item-internal-id">ID: {item.WorkersCompensationIncidentId}</p>
                                            {item.IncidentStatusTypeDesc === "Open" && <div className="WorkersCompItemCardHeaderStatusBarOpen"></div>}
                                            <div className="WorkersCompItemCardHeaderItem" id="workers-comp-item-card-header-item-incident-date">
                                                <p>{moment(item.IncidentDateUTC).format("YYYY[-]MM[-]DD")}</p>
                                            </div>
                                            <div className="WorkersCompItemCardHeaderItem" id="workers-comp-item-card-header-item-incident-number">
                                                {item.ClaimNumber && <p>Claim # {item.ClaimNumber}</p>}
                                                {/* {!item.ClaimNumber && <div id="work-comp-missing-claim-num">
                                                    <p>Claim #</p>
                                                    <p id="work-comp-missing-claim-num-warn">*NA*</p>
                                                </div>} */}
                                            </div>
                                            <div className="WorkersCompItemCardHeaderItem" id="workers-comp-item-card-header-item-incident-desc">
                                                <p>{item.IncidentStatusTypeDesc}</p>
                                            </div>
                                            <div className="WorkersCompItemCardHeaderItem" id="workers-comp-item-card-header-item-incident-type">
                                                <p>{item.IncidentTypeDesc}</p>
                                            </div>
                                            <div className="WorkersCompItemCardHeaderItem" id="workers-comp-item-card-header-item-incident-state">
                                                <p>{item.StateName}</p>
                                            </div>
                                            <div className="WorkersCompItemCardHeaderControls">
                                                {/* <div className="WorkersCompItemCardHeaderControlsExpandFS">
                                                    <span id="workers-comp-item-open-full" className="material-icons">open_in_full</span>
                                                </div> */}
                                                <div className="WorkersCompItemCardHeaderControlsArrow">
                                                    {this.state.selectedIncident !== index && <span className="material-icons">expand_more</span>}
                                                    {this.state.selectedIncident === index && <span className="material-icons">expand_less</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Toggle>
                                    {/* {this.state.selectedIncident === index && <Accordion.Collapse eventKey="0">
                                        <Incident
                                            WorkersCompensationIncidentId={item.WorkersCompensationIncidentId}
                                            reference={this.state.reference}
                                        />
                                    </Accordion.Collapse>} */}
                                </Card>
                            </Accordion>
                        </div>
                    )}
                </div>}
                {this.state.selectedIncident >= 0 && <div className="WorkersCompItem" key={`workers-comp-item-${this.state.selectedIncident}`}>
                    <Accordion defaultActiveKey="0">
                        <Card className="WorkersCompCard">
                            <Accordion.Toggle id="workers-comp-accordion-toggle" as={Card.Header} eventKey="0" >
                                <div className="WorkersCompItemCardHeader" id="workers-comp-card-header" onClick={() => this.setOpenIncident(this.state.selectedIncident)}>
                                    <p id="work-comp-item-internal-id">ID: {workersCompItems[this.state.selectedIncident].WorkersCompensationIncidentId}</p>
                                    {workersCompItems[this.state.selectedIncident].IncidentStatusTypeDesc === "Open" && <div className="WorkersCompItemCardHeaderStatusBarOpen"></div>}
                                    <div className="WorkersCompItemCardHeaderItem" id="workers-comp-item-card-header-item-incident-date">
                                        <p>{moment(workersCompItems[this.state.selectedIncident].IncidentDateUTC).format("YYYY[-]MM[-]DD")}</p>
                                    </div>
                                    <div className="WorkersCompItemCardHeaderItem" id="workers-comp-item-card-header-item-incident-number">
                                        {workersCompItems[this.state.selectedIncident].ClaimNumber && <p>Claim # {workersCompItems[this.state.selectedIncident].ClaimNumber}</p>}
                                        {!workersCompItems[this.state.selectedIncident].ClaimNumber && <div id="work-comp-missing-claim-num">
                                            <p>Claim #</p>
                                            {/* <p id="work-comp-missing-claim-num-warn">*NA*</p> */}
                                        </div>}
                                    </div>
                                    <div className="WorkersCompItemCardHeaderItem" id="workers-comp-item-card-header-item-incident-desc">
                                        <p>{workersCompItems[this.state.selectedIncident].IncidentStatusTypeDesc}</p>
                                    </div>
                                    <div className="WorkersCompItemCardHeaderItem" id="workers-comp-item-card-header-item-incident-type">
                                        <p>{workersCompItems[this.state.selectedIncident].IncidentTypeDesc}</p>
                                    </div>
                                    <div className="WorkersCompItemCardHeaderItem" id="workers-comp-item-card-header-item-incident-state">
                                        <p>{workersCompItems[this.state.selectedIncident].StateName}</p>
                                    </div>
                                    <div className="WorkersCompItemCardHeaderControls">
                                        {/* <div className="WorkersCompItemCardHeaderControlsExpandFS">
                                                    <span id="workers-comp-item-open-full" className="material-icons">open_in_full</span>
                                                </div> */}
                                        <div className="WorkersCompItemCardHeaderControlsArrow">
                                            {/*r-18-lint-bk*/}
                                            {/*eslint-disable-next-line*/}
                                            {this.state.selectedIncident !== this.state.selectedIncident && <span className="material-icons">expand_more</span>}
                                            {/*r-18-lint-bk*/}
                                            {/*eslint-disable-next-line*/}
                                            {this.state.selectedIncident === this.state.selectedIncident && <span className="material-icons">expand_less</span>}
                                        </div>
                                    </div>
                                </div>
                            </Accordion.Toggle>
                            {/*r-18-lint-bk*/}
                            {/*eslint-disable-next-line*/}
                            {this.state.selectedIncident === this.state.selectedIncident && <Accordion.Collapse eventKey="0">
                                <Incident
                                    WorkersCompensationIncidentId={workersCompItems[this.state.selectedIncident].WorkersCompensationIncidentId}
                                    workCompReference={this.state.workCompReference}
                                    reference={this.props.reference}
                                    contextUserId={this.props.userId}
                                    hasEdits={this.props.hasEdits}
                                    refreshIncidents={this.props.refresh}
                                    setOpenIncident={this.setOpenIncident}
                                    toggleViewAll={this.toggleViewAll}
                                    readOnly={readOnly}
                                />
                            </Accordion.Collapse>}
                        </Card>
                    </Accordion>
                </div>}
                {this.state.createNewIncident && this.state.workCompReference.incidentTypes.length > 0 &&
                    < NewIncident
                        toggle={this.toggle}
                        employee={this.props.employee}
                        workCompReference={this.state.workCompReference}
                        refresh={this.props.refresh}
                    />}
                <Naggy
                    disabledElements={["workers-comp-accordion-toggle"]}
                    isDirty={this.props.isDirty}
                    toggleDirty={this.props.hasEdits}
                    discard={() => this.setOpenIncident(-1)}
                    message={this.discardMsg}
                />
            </div>
        )
    }
}

export default WorkersComp